import { Grid } from 'bold-ui'

// TODO delorean: implementar secao indicacao clinica
export function MamografiaIndicacaoClinicaModalStep() {
  return <Grid></Grid>
}
